<template>
  <div class="mobile-title bg-secondary p-2 pb-3 w-100 p-fixed">
    <span class="font-supersonic font-size-2em">HALO PROTOCOL</span>
  </div>
  <div class="container protocol-container text-white">
    <!--<full-page ref="fullpage" :options="fpOptions" :skip-init="true">-->
    <div class="w-100">
      <div class="section mt-2">
        <div class="section-box section-box-1">
          <h3 class="section-title page-title title-box border-third bg-black d-inline-block pl-3 pr-3 mt-2 font-size-2em">PROTOCOL</h3>
          <div class="mt-3">
            <p class="mb-2 font-size-1-5em section-sub-title">To Create Growth Interactive NFT</p>
            <p>Now the NFT market is in a serious bubble.</p>
            <p>The pictures deviate from the purpose of the metaverse virtual assets with confirmed rights.</p>
            <p>People focus on the speculation of the pictures' appreciation, but the price of NFTs is far from the actual value.</p>
            <p>HALO Protocol helps artists produce interactive NFTs, the visual identity data credential, and will be the next leading blue chip.</p>
            <p>It naturally corresponds to the paradigm that metaverse UGC identity image is generated by the CryptoPunks culture.</p>
            <p>With the attribute of decentralized cooperation, stronger social demand will be indeed created in this way, and social values and expressions are further given to the asset attributes of the CyptoPunks culture.</p>
            <p>Entering a unique circle with virtual identities represented by the interactive NFTs will constitute the underlying logic and starting point in the metaverse social contacts and the crucial needs of all metaverse social products.</p>
            <p>Holders own not only a set of unique images but the underlying certificates.</p>
            <p>Native people in Web3.0 are fed up with the existing identity marking system, such as the ENS-like single text ID, inanimate profile, stereotyped JPG, outdated blog system, independent domain, and personal homepage.</p>
            <p>Now HALO offers a new possibility to make your identity mark truly belong to you by using interactive 3D NFTs, the unique visual identity images, to the original Web3.0 world.</p>
          </div>
          <div class="mt-5 clearfix">
            <div class="text-center mt-3">
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em">PHYSICAL WORLD</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">WEB1.0 & 2.0</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">WEB3.0</p>
            </div>
            <div class="text-center mt-3">
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em">COORDINATES</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">IP ADDRESS</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">WALLET ADDRESS</p>
            </div>
            <div class="text-center mt-3">
              <p class="w-20 section-title title-box border-third bg-black d-inline-block">ROOM NUMBER</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">DOMAIN NAME</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">ENS</p>
            </div>
            <div class="text-center mt-3">
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em">IMAGE/IDENTITY</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">PROFILE</p>
              <p class="w-20 section-title title-box border-third bg-black d-inline-block font-size-1em ml-3">VISUAL DID</p>
            </div>
          </div>
        </div>
      </div>
      <div class="section mt-5">
        <div class="section-box">
          <div class="mt-3 w-80 section-content-box">
            <p class="mb-2">In the real world, virtual humans have partly replaced real humans in business endorsements and gained great commercial value. In our metaverse spectacular label, HALO NFTs will grow and enter the next stage according to the trading weight, users voting, and commercial value. The TOP 10 virtual humans will be supported with the blockchain authentic rights and ancillary trademark copyrights. Users owning HALO NFTs will get commercial value in the meanwhile.</p>
          </div>
          <div class="mt-5 w-80 section-content-box">
            <p class="mb-2 font-size-1-5em section-sub-title">To Create an Open Protocol</p>
            <p>Introduction:</p>
            <p>The underlying core of the HALO project is HALO Protocol, a 3D interactive visual credential identity service specially designed for Web3.0 metaverse natives. It allows users to manage and control their metaverse digital identities and images freely and easily without intermediaries.</p>
            <p class="mt-3">Existing problems: </p>
            <p>In the current Web3.0 identity service, users come up against many problems.</p>
            <p>Most people have only a string of meaningless and undifferentiated text (wallet address) as the symbol of their identities;</p>
            <p>Most identity standards are too isolated to interoperate;</p>
            <p>Identities may be difficult to retrieve if a trusted device is lost;</p>
            <p>The possibility of inconsistent results from multiple logins when using Dapps.</p>
            <p class="mt-3">HALO Protocol optimizes the above problems: </p>
            <p>The unique interactive visual credential identity in Web3.0 can be easily created by using HALO NFTs, which ensures uniqueness at both levels of the data credential and vision;</p>
            <p>HALO protocol is transparent enough to allow interconnection among any Dapps that support smart contracts (EVM compatible), with high interoperability;</p>
            <p>Advanced identity management allows identity retrieval by binding the user's creation features;</p>
            <p>Data consistency when logging into each Dapp is guaranteed by the underlying data credential deposition module.</p>
          </div>
        </div>
      </div>
      <div class="section mt-5">
        <div class="section-box">
          <div class="mt-3 text-center">
            <img v-if="isMobile" class="w-80 d-inline-block" alt="protocol" src="../assets/images/protocol_illu1m.png" />
            <img v-else class="w-100 d-inline-block" alt="protocol" src="../assets/images/protocol_illu1.png" />
          </div>
        </div>
      </div>
      <div class="section mt-5">
        <div class="section-box layer-section">
          <div class="mt-3">
            <p>HALO Project will provide a new paradigm compatible with the four-layer mode---interactive NFTs, the unique visual identity credential:</p>
            <p>Layer4---HALO Interactive NFTs</p>
            <p>Layer3---HALO Protocol Credential System</p>
            <p>Layer2---HALO Protocol Oracle System & HALO API</p>
            <p>Layer1---HALO DID Paradigm Standard</p>
            <p class="mt-4 layer-title">Layer 1: Identifiers and standards</p>
            <p class="w-80">Standards, identifiers, and namespaces create a common layer of trust, ensuring standardization, portability, and interoperability. They also allow network registration and DID management, providing developers and users with the rules and context of the network's ID system.</p>
            <p class="w-80">HALO DID system is a key participant in this layer and is also the cornerstone of the ecosystem. It acts as a hub for developing, discussing, and managing all the activities needed to create and maintain an interoperable and open ecosystem for the DID stack.</p>
            <p class="mt-4 layer-title">Layer 2: Infrastructure</p>
            <p class="w-80">Infrastructure and proxy frameworks allow direct interaction between applications and verifiable data registrations. These solutions include communication, storage, and secret key management.</p>
            <p class="w-80">HALO Protocol Oracle System and HALO API will constitute important parts of the infrastructure layer.</p>
            <p class="mt-4 layer-title">Layer 3: Credentials</p>
            <p class="w-80">Credentials must be managed, updated, and exchanged. This layer aims to solve how DID negotiates the control certification and authentication, and securely passes data between identity owners.</p>
            <p class="w-80">HALO Protocol Credential System will be responsible for managing all interactions related to the credential network.</p>
            <p class="mt-4 layer-title">Layer 4: Applications, wallets, and products</p>
            <p>This layer is probably the most familiar to users, and it aims to provide consumers with the value and use cases that can be used and consumed immediately.</p>
          </div>
        </div>
      </div>
      <div class="section mt-5 pb-5">
        <div class="section-box">
          <div class="mt-3 text-center">
            <img v-if="isMobile" class="w-80 d-inline-block mt-5" alt="protocol" src="../assets/images/protocol_illu2m.png" />
            <img v-else class="w-100 d-inline-block" alt="protocol" src="../assets/images/protocol_illu2.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
export default {
  name: 'Protocol',

  setup() {
    let fpOptions = ref({
      navigation: true
    });

    const isMobile = ref(false);
    const fullpage = ref(null);

    const checkMobile = () => {
      let windowWidth = document.body.clientWidth || document.documentElement.clientWidth;
      if(windowWidth <= 960) {
        isMobile.value = true;
      }
      else {
        isMobile.value = false;
      }
    }

    onMounted (() => {
      setTimeout(() => {
        checkMobile();
        /*
        setTimeout(() => {
          fullpage.value.init();
        }, 100);
        */
      }, 100);
      window.addEventListener('resize', () => {
        checkMobile();
      });
    });

    return {
      fpOptions,
      isMobile,
      fullpage,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mobile-title {
  display: none;
}

.title-box {
  border-style: solid;
  border-width: 2px;
  border-radius: 1.4rem;
  height: 2.8rem;
  overflow: hidden;
  line-height: 2.5rem;
  letter-spacing: 1px;
}

@media screen and ( max-width: 960px ) {
  .mobile-title {
    display: block;
    position: relative;
    z-index: 2;
  }

  .page-title {
    display: none;
  }

  .section-title {
    margin: 10px 1.666%;
    height: 60px;
    line-height: 54px;
    font-size: 8px;
    border-radius: 30px;
    overflow: hidden;
    width: 30%;
    float: left;
  }

  .section-sub-title {
    font-size: 16px;
  }
  
  .section-box {
    padding-top: 0;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }

  .section-content-box {
    width: 100%;
    padding-left: 0;
  }

  .layer-section p {
    margin-top: 3px;
    width: 100%;
  }

  .layer-section .layer-title {
    margin-top: 15px;
  }
}
</style>
